import React from 'react'

export interface FormProps {
	onSubmit?: (values: any) => void
	children?: any
}

export const Form = ({ onSubmit, children }: FormProps) => {
	const handleSubmit = async (e: any) => {
		e.preventDefault()
		const inputRefs = e?.target.querySelectorAll('input')

		let values: any[] = []

		const setValueIntoForm = (inputRef: any) => {
			const inputId = inputRef?.getAttribute('id')
			if (inputId) {
				const formattedInputId = inputId.includes('input-')
					? inputId.split('input-')[1]
					: inputId
				if (
					formattedInputId !== 'undefined' &&
					!formattedInputId.includes('index')
				) {
					values = [
						...values,
						{
							id: inputId,
							questionAnswerId: inputRef.value,
						},
					]
				}
			}
		}

		inputRefs.forEach(setValueIntoForm)

		onSubmit && onSubmit(values)
	}

	return <form onSubmit={handleSubmit}>{children}</form>
}
